"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileMetadata = void 0;
const common_1 = require("../../common");
class FileMetadata extends common_1.MongoDocument {
}
exports.FileMetadata = FileMetadata;
//# sourceMappingURL=file-metadata.model.js.map